import { createAction, props } from '@ngrx/store';
import { GetSubscriptionStatus$Response } from '@api/service';

export const getStatus = createAction('[App] Get status');
export const getStatusFail = createAction('[App] Get status Fail', props<{ error: any }>());
export const getStatusSuccess = createAction('[App] Get status Success', props<GetSubscriptionStatus$Response>());
